import './common.scss';




/** WEBPACK FOOTER **
 ** ./components/Common/common.js
 **/